// Site content, sourced from the Laravel CMS.
//
// `content.json` is a build-time snapshot written by `npm run content:fetch`
// (which calls the CMS at $VUE_APP_API_URL). It is committed so the site can
// always build and render, even if the CMS is unreachable.
//
// The exports below are read synchronously at module load — no loading states,
// no async.
import content from './content.json'

export const products = content.products
export const productCategories = content.productCategories
export const caseStudies = content.caseStudies
export const blogPosts = content.blogPosts
export const team = content.team
export const milestones = content.milestones

/** The bilingual solutions shown on the Home, Solutions and detail pages. */
export const solutions = content.solutions || []

/**
 * Bilingual website copy: { shared, en, ar }. PHP encodes an empty array as
 * `[]`, so an unseeded CMS yields an array here; treat that as "no copy".
 */
export const site = Array.isArray(content.site) ? {} : (content.site || {})

/** Per-page copy: pages.home, pages.about, pages.contact, … (English only). */
export const pages = content.pages

/** Legacy nav, footer, social links and tab titles (still used by the mobile app). */
export const globalContent = content.global

export default content
